import {useLocation, useNavigate} from 'react-router-dom';

import guideStory from '../../../../../assets/image/shop/guideStory.png';
import CustomHeader from '../../../../../components/mazraeKit/headers/homeHeader';
const GuideStory = () => {
  const navigate = useNavigate();
  const {state} = useLocation();

  return (
    <div>
      <CustomHeader
        title="راهنمای استوری"
        preIcon=""
        isActiveRightIcon={false}
        postComponent={() => (
          <i
            className="icon-nameClose-remove text-[25px]"
            onClick={() => {
              navigate(`/set-story/${state.storyGuid}`);
            }}
          />
        )}
      />
      <img src={guideStory} alt="guide_story" />
    </div>
  );
};

export default GuideStory;
